/** Dinh dang so / thoi gian / do tre. Mot cho duy nhat de ca dashboard hien giong nhau. */

const NUMBER_FMT = new Intl.NumberFormat('vi-VN');
const PERCENT_FMT = new Intl.NumberFormat('vi-VN', {
  style: 'percent',
  maximumFractionDigits: 1,
});
const USD_FMT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 4,
});

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return NUMBER_FMT.format(value);
}

/**
 * Ti le giai noi bo.
 *
 * Dac ta khong noi ro localRate la 0..1 hay 0..100. Nhan ca hai: gia tri > 1 duoc coi
 * la da nhan 100 san. Chap nhan mot truong hop bien vo hai (dung 100% se hien "100%"
 * du server tra 1 hay 100) de doi lai khong bao gio hien "9530%".
 */
export function formatRatio(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  const ratio = value > 1 ? value / 100 : value;
  return PERCENT_FMT.format(ratio);
}

export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return USD_FMT.format(value);
}

/** Duoi 1 giay hien ms cho chinh xac; tren 1 giay hien s cho de doc. */
export function formatLatency(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '—';
  if (ms < 1000) return `${NUMBER_FMT.format(Math.round(ms))} ms`;
  return `${NUMBER_FMT.format(Math.round(ms / 100) / 10)} s`;
}

function toDate(iso: string | null | undefined): Date | null {
  if (iso === null || iso === undefined || iso.length === 0) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(iso: string | null | undefined): string {
  const d = toDate(iso);
  if (d === null) return '—';
  return d.toLocaleString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatTimeShort(iso: string | null | undefined): string {
  const d = toDate(iso);
  if (d === null) return '—';
  return d.toLocaleString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** "3 phut truoc" — de nhin luot qua cot lastUsedAt ma biet key nao con song. */
export function formatRelative(iso: string | null | undefined): string {
  const d = toDate(iso);
  if (d === null) return 'chưa dùng';
  const diffSec = Math.round((Date.now() - d.getTime()) / 1000);
  if (diffSec < 0) return 'vua xong';
  if (diffSec < 60) return `${diffSec} giay truoc`;
  const min = Math.floor(diffSec / 60);
  if (min < 60) return `${min} phut truoc`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour} gio truoc`;
  const day = Math.floor(hour / 24);
  if (day < 30) return `${day} ngay truoc`;
  return formatTimeShort(iso);
}

/**
 * Nhan cot cua bieu do. Khoang 24h chia theo gio nen chi can gio;
 * 7d/30d chia theo ngay nen chi can ngay/thang.
 */
export function formatBucketTick(iso: string, hourly: boolean): string {
  const d = toDate(iso);
  if (d === null) return iso;
  return hourly
    ? d.toLocaleString('vi-VN', { hour: '2-digit', minute: '2-digit', hour12: false })
    : d.toLocaleString('vi-VN', { day: '2-digit', month: '2-digit' });
}

export function formatBucketLabel(iso: string, hourly: boolean): string {
  const d = toDate(iso);
  if (d === null) return iso;
  return hourly
    ? d.toLocaleString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    : d.toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatConfidence(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toFixed(3);
}

/** JSON dep cho khung chi tiet. Khong bao gio nem loi ke ca khi gap tham chieu vong. */
export function prettyJson(value: unknown): string {
  if (value === null || value === undefined) return '—';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

/** Ban rut gon mot dong cua solution, dung trong bang. */
export function compactJson(value: unknown): string {
  if (value === null || value === undefined) return '—';
  try {
    const text = JSON.stringify(value);
    return text === undefined ? '—' : text;
  } catch {
    return String(value);
  }
}

export function truncate(text: string, max: number): string {
  return text.length <= max ? text : `${text.slice(0, max - 1)}…`;
}
